"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._isSSR = void 0;
exports.setSSR = setSSR;
/**
 * @deprecated Use `canUseDOM` from `@fluentui/utilities` instead.
 */
exports._isSSR = false;
/**
 * Helper to set ssr mode to simulate no window object returned from getWindow helper.
 *
 * @deprecated Use `canUseDOM` from `@fluentui/utilities` instead.
 */
function setSSR(isEnabled) {
    throw new Error('setSSR has been deprecated and is not used in any utilities anymore.' +
        ' Use canUseDOM from @fluentui/utilities instead.');
}
//# sourceMappingURL=setSSR.js.map